import { http } from './http';

export interface FasterMenuType{
    userName: string;
    customerNo: number;
    trnType : string;
    favoriteSeq : number;
    isInFavoriteList: boolean;
}

export const updateFasterMenus = async (trnType: string, index: number): Promise<FasterMenuType> => {
    const req = {
        "favorites" : [{
            "trnType": trnType,
            "favoriteSeq": index + 1
        }]
    }
    const { data } = await http.post<any>(`transaction/favorite-changeseq-bulk`, req);
    return data;
};

export const addFavoriteFasterMenus = async (trnType: string): Promise<FasterMenuType> => {
    const req = {
        "trnType": trnType,
    }
    const { data } = await http.post<any>(`transaction/favorite-create`, req);
    return data;
};

export const deleteFavoriteFasterMenus = async (trnType: string): Promise<FasterMenuType> => {
    const req = {
        "trnType": trnType,
    }
    const { data } = await http.post<any>(`transaction/favorite-delete`, req);
    return data;
};

export const getFavoriteAll = async (): Promise<FasterMenuType[]> => {
    const { data } = await http.get<FasterMenuType[]>(`transaction/favorite-get-full-trn`);
    return data;
};
